import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Create the script element
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window,document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '684174471106131');
      fbq('track', 'PageView');
    `;
    // Create the noscript element with the tracking pixel image
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=684174471106131&ev=PageView&noscript=1';
    noscript.appendChild(img);
    // Append elements to the document head
    document.head.appendChild(script);
    document.head.appendChild(noscript);
    // Cleanup function to remove elements when component unmounts
    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
      if (document.head.contains(noscript)) {
        document.head.removeChild(noscript);
      }
    };
  }, []); // Empty dependency array ensures this runs once on mount
  return null; // This component doesn't render anything
}